import React, { memo, useEffect, useState, useRef } from "react";
import AsyncSelect from "react-select/async";

const CodingRow = memo(({
    row,
    serverCostCodeId,
    costCodes,
    loadCostCodesOptions,
    summaryDone,
    isNextFocus,
    lastEnteredCode,
    applyCostCodeToItem,
    getCodeString,
}) => {
    const invoiceItemId = row.invoice_item_id;
    const [value, setValue] = useState(null);
    const lastServerValue = useRef(serverCostCodeId);
    const selectRef = useRef(null);

    useEffect(() => {
        if (
            isNextFocus &&
            selectRef.current
        ) {
            selectRef.current.focus();
            selectRef.current.onMenuOpen?.();
        }


    }, [isNextFocus]);
    const handleKeyDown = (e) => {
        const isPaste =
            e.key === "v" &&
            (e.ctrlKey || e.metaKey);

        //detect ctrl+v command and set the code to be input

        if (!isPaste) return;

        if (lastEnteredCode) {
            // stop browser from pasting text into the input
            e.preventDefault();

            const matched = costCodes.find(c => c.dbid == lastEnteredCode);

            if (matched) {
                const label = getCodeString(matched);
                handleChange({
                    value: matched.dbid,
                    label: label
                }, true); //has paste action
            }
        }

    };
    useEffect(() => {

        if (!serverCostCodeId || !costCodes?.length) {
            setValue(null);
            lastServerValue.current = serverCostCodeId;
            return;
        }

        //protection against serever value if we are in the middle of updating it ourselves
        if (serverCostCodeId === lastServerValue.current && value) return;

        //if empty, set it so
        if (!parseInt(serverCostCodeId)) {
            setValue(null);
            return;
        }

        const matched = costCodes.find(c => c.dbid == serverCostCodeId);

        if (matched) {
            const label = getCodeString(matched);
            setValue({
                value: matched.dbid,
                label: label
            });
        }

        lastServerValue.current = serverCostCodeId;
    }, [serverCostCodeId, costCodes]);

    const handleChange = (option, hasPasteAction = false) => {
        applyCostCodeToItem(
            invoiceItemId,
            option?.value || null, hasPasteAction
        );
    };

    const removeCode = () => {
        applyCostCodeToItem(
            invoiceItemId,
            null
        );
    };

    if (Number(row.total) === 0) return null;

    if (!summaryDone) {
        return (
            <div className="flex items-center gap-1">
                {value ? <span className="text-gray-600 text-l cursor-pointer w-6 h-6 text-center  leading-4.5 rounded-[50%] hover:text-orange-700 hover:underline" onClick={removeCode} href="#">x</span> : <span className="pl-[24px]"></span>}
                <div className="w-[100%]">
                    <AsyncSelect
                        ref={selectRef}
                        cacheOptions
                        loadOptions={loadCostCodesOptions}
                        value={value}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Search Cost Codes..."
                        noOptionsMessage={({ inputValue }) =>
                            inputValue ? "No results found" : "Type code # or name to search"
                        }
                    />
                </div>

            </div>

        );
    }

    return <span>{row.cost_code_description ? (row.cost_code_string + ' - ' + row.cost_code_description) : value?.label}</span>;
});

export default CodingRow;
